import { Container, Graphics, Sprite, Text } from "pixi.js";

import { symbolConfig } from "../UCConfig";
import { UCSymbolNames } from "../types/UCEnums";

export const simulateReelPositions = (
    index: number,
    yPosition: number,
    color: number
): Container => {
    const container: Container = new Container();
    const gr: Graphics = new Graphics();
    gr.lineStyle(1, 0xffffff);
    gr.beginFill(color);
    gr.drawRect(1, 1, symbolConfig.symbolWidth - 2, symbolConfig.symbolHeight - 2);
    gr.endFill();

    // gr.lineStyle(3, 0xffff00, 1);
    // gr.moveTo(symbolConfig.symbolWidth / 2, 0);
    // gr.lineTo(symbolConfig.symbolWidth / 2, placeholderHeight);
    // gr.moveTo(symbolConfig.symbolWidth / 2, placeholderHeight / 2);
    // gr.lineTo(symbolConfig.symbolWidth, placeholderHeight / 2);

    container.addChild(gr);

    let mainTxt = new Text(index.toString().toUpperCase(), {
        fontFamily: `Arial`,
        fontSize: 44,
        fontWeight: `bold`,
        fill: 0xffffff,
        align: `center`,
    });
    mainTxt.anchor.set(0.5, 0.5);
    mainTxt.position.set(symbolConfig.symbolWidth / 2, symbolConfig.symbolHeight / 2);
    container.addChild(mainTxt);

    // for (let counter = 0; counter < 2; counter++) {
    //     let posTxt = new Text((index + counter).toString().toUpperCase(), {
    //         fontFamily: `Arial`,
    //         fontSize: 32,
    //         fill: 0xffffff,
    //         align: `center`,
    //     });
    //     posTxt.anchor.set(0.5, 0.5);
    //     posTxt.position.set(
    //         symbolConfig.symbolWidth * 0.75,
    //         placeholderHeight / 4 + (placeholderHeight / 2) * counter
    //     );
    //     container.addChild(posTxt);
    // }

    container.y = yPosition;

    return container;
};

export const getDebugSymbolWithText = (symbolName: string): Sprite => {
    const sprite = new Sprite();

    let graphicsColor = 0x795548;

    if (symbolName.includes(UCSymbolNames.M1)) {
        graphicsColor = 0xe81e63;
    } else if (symbolName.includes(UCSymbolNames.M2)) {
        graphicsColor = 0xf44336;
    } else if (symbolName.includes(UCSymbolNames.M3)) {
        graphicsColor = 0xf87b53;
    } else if (symbolName.includes(UCSymbolNames.M5)) {
        graphicsColor = 0xefc090;
    } else if (symbolName.includes(UCSymbolNames.L1)) {
        graphicsColor = 0x009688;
    } else if (symbolName.includes(UCSymbolNames.L2)) {
        graphicsColor = 0x4caf50;
    } else if (symbolName.includes(UCSymbolNames.L3)) {
        graphicsColor = 0x8bc34a;
    } else if (symbolName.includes(UCSymbolNames.L4)) {
        graphicsColor = 0xcddc39;
    } else if (symbolName.includes(UCSymbolNames.L5)) {
        graphicsColor = 0x87e4a2;
    } else if (symbolName.includes(UCSymbolNames.MYSTERY)) {
        graphicsColor = 0x9c27b0;
    } else if (symbolName === UCSymbolNames.SCATTER) {
        graphicsColor = 0x000075;
    } else if (symbolName === UCSymbolNames.WILD) {
        graphicsColor = 0x3f51b5;
    } else if (symbolName === UCSymbolNames.F1) {
        graphicsColor = 0xff6961;
    } else if (symbolName === UCSymbolNames.F2) {
        graphicsColor = 0xffb480;
    } else if (symbolName === UCSymbolNames.F3) {
        graphicsColor = 0xe0b512;
    } else if (symbolName === UCSymbolNames.F4) {
        graphicsColor = 0x42d6a4;
    } else if (symbolName === UCSymbolNames.F5) {
        graphicsColor = 0x08cad1;
    } else if (symbolName === UCSymbolNames.F6) {
        graphicsColor = 0x59adf6;
    } else if (symbolName === UCSymbolNames.F7) {
        graphicsColor = 0x9d94ff;
    }

    let bg = new Graphics();
    bg.lineStyle(0, 0xff9900);
    bg.beginFill(graphicsColor, 1);
    bg.drawRect(0, 0, symbolConfig.symbolWidth, symbolConfig.symbolHeight);
    bg.endFill();
    sprite.addChildAt(bg, 0);

    let text = new Text(symbolName.toUpperCase(), {
        fontFamily: `Arial`,
        fontSize: 18,
        fontWeight: `bold`,
        fill: 0xffffff,
        align: `center`,
    });
    let text2 = new Text(symbolName.toUpperCase(), {
        fontFamily: `Arial`,
        fontSize: 18,
        fontWeight: `bold`,
        fill: 0x000000,
        align: `center`,
    });

    text.anchor.set(0.5, 0.5);
    text.position.set(symbolConfig.symbolWidth / 2, symbolConfig.symbolHeight / 2);
    text2.anchor.set(0.5, 0.5);
    text2.position.set(symbolConfig.symbolWidth / 2 + 2, symbolConfig.symbolHeight / 2 + 2);

    sprite.addChild(text2);
    sprite.addChild(text);

    return sprite;
};

export const getDebugGraphicsOnly = (
    symbolName: string,
    width?: number,
    height?: number
): Graphics => {
    let graphicsColor = 0x795548;

    if (symbolName.includes(UCSymbolNames.M1)) {
        graphicsColor = 0xe81e63;
    } else if (symbolName.includes(UCSymbolNames.M2)) {
        graphicsColor = 0xf44336;
    } else if (symbolName.includes(UCSymbolNames.M3)) {
        graphicsColor = 0xf87b53;
    } else if (symbolName.includes(UCSymbolNames.M5)) {
        graphicsColor = 0xefc090;
    } else if (symbolName.includes(UCSymbolNames.L1)) {
        graphicsColor = 0x009688;
    } else if (symbolName.includes(UCSymbolNames.L2)) {
        graphicsColor = 0x4caf50;
    } else if (symbolName.includes(UCSymbolNames.L3)) {
        graphicsColor = 0x8bc34a;
    } else if (symbolName.includes(UCSymbolNames.L4)) {
        graphicsColor = 0xcddc39;
    } else if (symbolName.includes(UCSymbolNames.L5)) {
        graphicsColor = 0x87e4a2;
    } else if (symbolName.includes(UCSymbolNames.MYSTERY)) {
        graphicsColor = 0x9c27b0;
    } else if (symbolName === UCSymbolNames.SCATTER) {
        graphicsColor = 0x000075;
    } else if (symbolName === UCSymbolNames.WILD) {
        graphicsColor = 0x3f51b5;
    } else if (symbolName === UCSymbolNames.F1) {
        graphicsColor = 0xff6961;
    } else if (symbolName === UCSymbolNames.F2) {
        graphicsColor = 0xffb480;
    } else if (symbolName === UCSymbolNames.F3) {
        graphicsColor = 0xe0b512;
    } else if (symbolName === UCSymbolNames.F4) {
        graphicsColor = 0x42d6a4;
    } else if (symbolName === UCSymbolNames.F5) {
        graphicsColor = 0x08cad1;
    } else if (symbolName === UCSymbolNames.F6) {
        graphicsColor = 0x59adf6;
    } else if (symbolName === UCSymbolNames.F7) {
        graphicsColor = 0x9d94ff;
    }

    let gr = new Graphics();
    gr.lineStyle(0, 0xff9900);
    gr.beginFill(graphicsColor, 1);
    gr.drawRect(
        0,
        0,
        width ? width : symbolConfig.symbolWidth,
        height ? height : symbolConfig.symbolHeight
    );
    gr.endFill();

    // if (width) {
    //     bg.width = width;
    // } else {
    //     bg.width = symbolConfig.symbolWidth;
    // }
    //
    // if (height) {
    //     bg.height = height;
    // } else {
    //     bg.height = symbolConfig.symbolHeight;
    // }
    //
    // sprite.addChild(bg);

    return gr;
};
